import { FC, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { useStores } from '@/utils'
import { IAnswerBase, IQuestionBase, MessageType } from '@/types'
import { AnswerCard } from '@components/molecules/AnswerCard'
import { AddAnswerForm } from '@components/molecules/AddAnswerForm'
import { LoginToAnswerButton } from '@/components/molecules/LoginToAnswerButton'
import styles from './index.module.scss'

type Props = {
  items: IAnswerBase[]
  question: IQuestionBase
}

export const AnswerGroup: FC<Props> = observer(({ items, question }) => {
  const { messages, viewer } = useStores()
  const [answers, setAnswers] = useState<IAnswerBase[]>(items)
  const [parentReply, setParentReply] = useState<IAnswerBase>(null)

  useEffect(() => {
    setAnswers(items)
  }, [items])

  const onClickDelete = async (id: string) => {
    // eslint-disable-next-line no-alert
    if (window.confirm('Are you sure to delete this reply?')) {
      const isSuccessful = await viewer.viewer.removeMyAnswer(id)
      if (isSuccessful) {
        setAnswers(answers.filter((a) => a.id !== id))

        messages.add({
          type: MessageType.Info,
          body: 'Reply deleted.',
          isTranslated: true,
          ttl: 5000,
        })
      }
    }
  }

  return (
    <>
      <div>
        <div className={styles.form}>
          {viewer.isSignedIn ? (
            <>
              <h2 className={styles.heading}>Reply</h2>
              <AddAnswerForm answers={answers} setAnswers={(newAnswers: IAnswerBase[]) => setAnswers(newAnswers)} />
            </>
          ) : (
            <LoginToAnswerButton />
          )}
        </div>
        {answers?.length === 0 ? (
          <div className={styles.noComments}>
            <p>No reply yet.</p>
          </div>
        ) : (
          <>
            <h2 className={styles.heading}>Replies</h2>
            <div>
              {answers.map((answer) => {
                return (
                  <div key={answer.id} className={styles.cardItem}>
                    <AnswerCard
                      question={question}
                      answer={answer}
                      answers={answers}
                      setAnswers={(newAnswers: IAnswerBase[]) => setAnswers(newAnswers)}
                      onClickDelete={(id: string) => onClickDelete(id)}
                      haveEditAndDelete={answer.respondent?.username === viewer.viewer?.username}
                      parentReply={parentReply}
                      setParentReply={(newParentReply: IAnswerBase) => setParentReply(newParentReply)}
                      isQuestioner={parentReply?.respondent.username === question?.questioner?.username}
                    />
                  </div>
                )
              })}
            </div>
          </>
        )}
      </div>
    </>
  )
})
